export enum PredefinedFieldType {
  achternaam = 'achternaam',
  adresRegel = 'adresRegel',
  bedrag = 'bedrag',
  bijlage = 'bijlage',
  bsn = 'bsn',
  cakKenmerk = 'cakKenmerk',
  datum = 'datum',
  email = 'email',
  geboortedatum = 'geboortedatum',
  geboortenaam = 'geboortenaam',
  geboorteplaats = 'geboorteplaats',
  geslacht = 'geslacht',
  huisnummer = 'huisnummer',
  iban = 'iban',
  land = 'land',
  plaats = 'plaats',
  postcode = 'postcode',
  provincie = 'provincie',
  radioYesNo = 'radioYesNo',
  regeling = 'regeling',
  straat = 'straat',
  telefoonnummer = 'telefoonnummer',
  text = 'text',
  textArea = 'textArea',
  voorletters = 'voorletters',
  voornaam = 'voornaam',
}
